<script setup lang="ts">
import { toRef } from 'vue';

import VLoader from '@components/loader/VLoader.vue';
import VTree from '@components/tree/VTree/VTree.vue';
import { useRolesAndPermissionsTranslate } from '@modules/roles-and-permissions/composables';

import type { IPermissionsTreeProps } from './types';
import VTreeNodeLeaf from '../VTreeNodeLeaf/VTreeNodeLeaf.vue';
import VTreeNodeParent from '../VTreeNodeParent/VTreeNodeParent.vue';
import { usePermissionsTree } from './composables';

const props = defineProps<IPermissionsTreeProps>();
const { translate } = useRolesAndPermissionsTranslate();
const {
  items,
  isRolesAndTreeLoading,
  isRolePermissionsLoading,
  isRolePermissionsFetching,
  isSavePermissionsLoading,
  handleChangePermission,
  isPermissionEnabled,
  isPermissionsChanged,
  handleSave,
  handleReset,
} = usePermissionsTree(toRef(props, 'namespace'), toRef(props, 'roleId'));
</script>

<template>
  <template v-data-qa-auto-id="'VPermissionsTree'" v-if="roleId">
    <VLoader :loading="isRolePermissionsLoading || isRolesAndTreeLoading">
      <div>
        <div class="p-card-subtitle mb-2 mt-3">
          {{ translate('EDIT_SUB_HEADER_PERMISSIONS') }}
        </div>
        <VTree :items="items">
          <template #parentNode="{ node }">
            <VTreeNodeParent
              :node="node"
              :show="isPermissionsChanged(node)"
              :is-loading="isRolePermissionsFetching"
              :is-saving="isSavePermissionsLoading"
              @save="handleSave"
              @reset="handleReset"
            />
          </template>
          <template #leafNode="{ node }">
            <VTreeNodeLeaf
              :node="node"
              :is-loading="isRolePermissionsFetching || isSavePermissionsLoading"
              :value="isPermissionEnabled(node)"
              @change="handleChangePermission"
            />
          </template>
        </VTree>
      </div>
    </VLoader>
  </template>
</template>
